<template>
  <template-corporation
    :pathName="pathName"
    :hasFinalTaxType="hasFinalTaxType"
    :fact="fact"
  >
    <div slot="info-contents" class="cck-detail">
      <div class="card">
        <div class="card-content">
          <div class="card-img">
            <img :src="OCTICONINFO" alt="OCTICONINFO" />
          </div>
          <div class="card-detail">
            <span class="white"
              >หากคุณต้องการจด VAT ล่วงหน้า สามารถขอจด VAT ออนไลน์ </span
            ><span @click="vatOnline" class="underline">ได้ที่นี่</span>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap-link">
          <chevron-right-link
            style="margin: 9px 0"
            @clickLink="goVatDefinition"
            caption="VAT คืออะไร"
          />
          <chevron-right-link
            style="margin: 9px 0"
            @clickLink="goVatCalculation"
            caption="วิธีการคำนวณ VAT"
          />
          <chevron-right-link
            @clickLink="goToFags"
            style="margin: 9px 0"
            caption="คำถามที่พบบ่อยเกี่ยวกับ VAT"
          />
        </div>
      </div>
    </div>
  </template-corporation>
</template>

<script>
import OCTICONINFO from "@/assets/images/octicon_info-24.png";
export default {
  name: "CorpNormalNeedRegister",
  props: ["hasFinalTaxType"],
  data() {
    return {
      OCTICONINFO,
      pathName: "corp_normal_need_register",
      fact: [
        "คุณจะมีค่าใช้จ่ายเพิ่มเติมที่ตามมาหลังจด VAT คือ ค่าใช้จ่ายในการทำบัญชีและตรวจสอบบัญชี",
        "การจด VAT ช่วยให้คุณมีหลักฐานในการขอเครดิตจากธนาคารในกรณีที่คุณต้องการเงินทุนเพื่อขยายกิจการในอนาคต",
      ],
    };
  },
  methods: {
    goVatDefinition() {
      this.$router.push({
        path: "/info/vat_definition",
      });
    },
    goVatCalculation() {
      this.$router.push({
        path: "/info/vat_calculation",
      });
    },
    goToFags() {
      this.$router.push({
        path: "/info/faqs",
      });
    },
  },
};
</script>

<style scoped>
.white {
  color: #ffffff;
}
.underline {
  font-weight: bold;
  color: #ffffff !important;
}
.card {
  background: #9bcc55;
  display: flex;
  width: 100%;
  justify-content: center;
}
.card-content {
  width: 100%;
  max-width: 352px;
  display: flex;
}
.card-img {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 16px;
}
.card-detail {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 19px;
}
.wrap {
  display: flex;
  justify-content: center;
  background: rgb(230 232 236 / 0.2);
  padding: 27px;
}
.wrap-link {
  max-width: 352px;
  width: 100%;
}
@media only screen and (min-width: 769px) {
  .card-content {
    max-width: 1120px;
    justify-content: center;
  }
  .card {
    margin: 0;
    margin-top: 40px;
  }
}
</style>
